import Filter from '@/src/components/organism/Filter';
import { useEffect, useRef, useState } from 'react';
import { donationFilters } from './filter';
import { useQuery } from '@tanstack/react-query';
import useQueryValues from '@/src/hooks/useQueryValues';
import MainContentTitle from '@/src/components/molecule/MainContentTitle';
import { AgGridReact } from 'ag-grid-react';
import Table from '@/src/components/atom/Table';
import { donationListColumn } from './column';
import SectionCardNoneTitle from '@/src/components/molecule/SectionCardNoneTitle';
import Typo from '@/src/components/atom/Typo';
import Button from '@/src/components/atom/Button';
import LucideIcon from '@/src/components/atom/Icons/LucideIcon';
import usePaginationQuery from '@/src/hooks/usePaginationQuery';
import { NAV_CONST } from '@/src/constants/nav';
import { Link, useNavigate } from 'react-router-dom';
import PATH from '@/src/routes/path';
import {
  getDonationsAPI,
  getDonationsExcelAPI,
} from '@/src/apis/rest/donation';
import ExcelDownloadButton from '@/src/components/atom/ExcelDownloadButton';

export default function DonationListPage() {
  const navigate = useNavigate();

  const { defaultValues } = useQueryValues({
    createdAt: ['createdAtFrom', 'createdAtTo'],
    startedAt: ['startedAtFrom', 'startedAtTo'],
  });
  const { page, pageSize, handlePageChange } = usePaginationQuery();

  const gridRef = useRef<AgGridReact>(null);
  const [values, setValues] = useState(defaultValues);

  const {
    data: donationListOrigin,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['donations', values, page, pageSize],
    queryFn: () => {
      return getDonationsAPI({
        ...values,
        page,
        pageSize,
      });
    },
  });

  useEffect(() => {
    if (isFetching && gridRef.current) {
      gridRef.current.api?.showLoadingOverlay();
    }
  }, [isFetching]);

  return (
    <>
      <MainContentTitle
        pageTitle={NAV_CONST.donationManagement}
        breadcrumbList={[NAV_CONST.donationManagement]}
      />
      <div className="mb-20 flex flex-col gap-6">
        <Filter
          title="검색 필터"
          filters={donationFilters()}
          onSubmit={values => {
            handlePageChange(1, pageSize, false);
            setValues(values);
          }}
        />
        <div className="flex flex-col gap-y-6">
          <SectionCardNoneTitle
            contentProps={{
              className: 'flex flex-col gap-y-4',
            }}
          >
            <div className="flex items-center justify-between">
              <Typo typoType="b18m">기부하기 목록</Typo>
              <div className="flex gap-2">
                <ExcelDownloadButton
                  disabled={
                    isError || isFetching || !donationListOrigin?.rows?.length
                  }
                  fileName="기부하기_리스트"
                  downloadExcelAPI={getDonationsExcelAPI}
                  searchParams={values}
                />
                <Link to={PATH.DONATION_CREATE}>
                  <Button buttonSize="medium" onClick={() => {}}>
                    <div className="flex items-center gap-x-2">
                      <LucideIcon name="Plus" color="white" />
                      기부하기 등록
                    </div>
                  </Button>
                </Link>
              </div>
            </div>

            <Table
              ref={gridRef}
              rowData={isError ? [] : donationListOrigin?.rows || []}
              isPaginationDataMapping
              columnDefs={donationListColumn(e => {
                navigate(PATH.DONATION_DETAIL.replace(':id', String(e)));
              })}
              total={donationListOrigin?.count || 0}
              page={page}
              pageSize={pageSize}
              handlePaginationClick={handlePageChange}
            />
          </SectionCardNoneTitle>
        </div>
      </div>
    </>
  );
}
